import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ToastService } from "src/app/services/toast.service";
import { ModalController } from "@ionic/angular";
import { ApactaApiSdkService } from "src/app/services/apacta-api-sdk.service";
import { DefaultApiInterface, Vendor } from "@apacta/sdk/src";
import { sentryCaptureException } from "src/app/utility/errors";

@Component({
    selector: "app-vendors",
    templateUrl: "./vendors.component.html",
    styleUrls: ["./vendors.component.scss"],
    standalone: false,
})
export class VendorsComponent implements OnInit {
    @Input() searchParam: string = "";
    @Input() entity!: string;
    @Input() inputSelectedVendor: string = null;
    @Output() onVendorSelect = new EventEmitter();

    public vendors: Vendor[] = [];
    public loading = true;
    public selectedVendor: string = null;

    private defaultSdk: DefaultApiInterface;
    private preservedVendors: Vendor[] = [];

    constructor(
        private modalCtrl: ModalController,
        private toastService: ToastService,
        private apactaSdk: ApactaApiSdkService
    ) {}

    ngOnInit() {
        this.selectedVendor = this.inputSelectedVendor || null;
        this.defaultSdk = this.apactaSdk.configuration();
        this.getVendors();
    }

    public getVendors() {
        const params = {
            q: this.searchParam,
            withPriceFile: this.entity === "getVendorProducts",
            withExpense: this.entity === "getExpenseLinesProducts",
        };

        this.defaultSdk
            .getVendors(params)
            .then((vendors) => {
                if (vendors?.data.length === 0) {
                    this.modalCtrl.dismiss();
                    this.toastService.showToastMessage("TOAST.NO_VENDORS_FOUND", {
                        color: "danger",
                        position: "top",
                        showCloseButton: true,
                        duration: 3000,
                    });
                    return;
                }
                this.preservedVendors = vendors.data;
                this.vendors = vendors.data;
                this.loading = false;
            })
            .catch((err) => {
                this.modalCtrl.dismiss();
                sentryCaptureException(err);
                this.toastService.showGeneralErrorMessage();
            });
    }

    public selectVendor(vendorId?: string): void {
        this.onVendorSelect.emit(vendorId || null);
        this.modalCtrl.dismiss();
    }

    public filterVendors() {
        if (this.searchParam.length >= 1 || this.searchParam.length === 0) {
            const query = this.searchParam.toLowerCase() || "";
            this.vendors = this.preservedVendors.filter((d) =>
                d.name.toLowerCase().includes(query)
            );
        }
    }
}
